import { Box, Paper, Typography } from "@mui/material";
import details from "../../../../../data/details.json";
import LocationHelmet from "../../../../../Helmets/LocationHelmet";

export default function MobileLocationPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        m: 3,
        mt: 5,
      }}
    >
      <LocationHelmet />
      <Paper>
        <Typography sx={{ m: 1 }}>{details.address}</Typography>
        <Box sx={{ m: 1 }}>
          <iframe
            title="location"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d787.2332444360926!2d23.936723269656746!3d37.8852500567039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzfCsDUzJzA2LjkiTiAyM8KwNTYnMTQuNSJF!5e0!3m2!1sel!2sgr!4v1773084623336!5m2!1sel!2sgr"
            width="90%"
            height="300"
            style={{ border: 0 }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </Box>
      </Paper>
    </Box>
  );
}
